module.exports = __webpack_public_path__ + "media/images/Sensibilisation des clients-b40b8d354029c08dd7b46a125545267b.svg";